export const styles = {
  formContainer: 'tw-flex tw-flex-col tw-h-full tw-min-h-0 tw-gap-6',
  offeringsSection: 'tw-flex tw-flex-col tw-flex-[0_0_80%] tw-min-h-0 tw-gap-4',
  offeringsScrollContainer: 'tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-border tw-border-neutral-200 tw-rounded tw-p-2 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-3',
  offeringGroup: 'tw-pl-4 tw-border-l tw-border-neutral-200',
};
